<template>
<div>
	<div class="title">
		<div>
			<h1>Reporting Global<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
		</div>
		<div class="text-right">
			<button
				class="green-btn"
				@click="excel"
				v-bind:class="{disabled_btn: !allReporting || allReporting.length === 0}"
				v-bind:disabled="!allReporting || allReporting.length === 0">
				<i class="fa fa-download" aria-hidden="true"></i> Téléchargez
			</button>
		</div>
	</div>
	<v-dialog/>
	<modal 	name="modal-share"
		:classes="['v--modal', 'modal-success']"
		:pivot-y="0.2"
		:width="300"
		:height="195">
		<div class="confirm-modal-content">
			<div class="modal-title">
				<h6>Partager cette entrée avec</h6>
			</div>
			<div class="dialog-content">
				<select v-model="user_id_notification" required>
					<option v-for="data in allUtilisateurs" v-bind:value="data.user.id">{{ data.user.name }}</option>
				</select>
			</div>
			<div class="dialog-buttons">
				<button @click="share">Confirmer</button>
			</div>
		</div>
	</modal>

	<modal 	name="modal-confirm"
			:classes="['v--modal', 'modal-confirm']"
			:pivot-y="0.2"
			:width="400"
			:height="125">
		<div class="confirm-modal-content">
			<div class="modal-title">
				<h6>Voulez-vous supprimer cette ligne ?</b></h6>
			</div>
			<div class="modal-button">
				<button @click="$modal.hide('modal-confirm')">Annuler</button>
				<button @click="destroy">Confirmer</button>
			</div>
		</div>
	</modal>

	<div class="row main-wrap">
		<div class="col-md-12">
			<div class="onglet">
				<select v-model="client" required @change="reporting">
					<option value="" selected disabled>Client</option>
          <template v-if="current_user_role === 'admin' || current_user_role == 'Consultant'">
            <option class="row clients-assignes-content" :value="all_clients">
              Tous les clients
            </option>
          </template>
					<template v-for="client in allClients">

						<template v-if="current_user_role === 'admin'">
							<option class="row clients-assignes-content" v-bind:value="client.id">
								{{ client.user.name }}
							</option>
						</template>
						<template v-else>
							<template v-for="utilisateur_assigne in client.utilisateur">
								<option class="row clients-assignes-content"  v-if="utilisateur == utilisateur_assigne.iduser" v-bind:value="client.id">
									{{ client.user.name }}
								</option>
							</template>
						</template>
					</template>
				</select>
			</div>
			<div class="section-bg">
				<form autocomplete="off" @submit="submitForm">
					<div class="row">
						<div class="col-md-6">
							<hr class="hr-text" data-content="Général">
							<div class="row" v-if="updating && current_user_role != 'admin'">
								<div class="col-sm-12 text-danger">
									Vous êtes en mode édition de ligne<br><br>
								</div>
							</div>
							<div class="row" v-else>
								<div class="form-group col-sm-4">
									<label for="nom">Nom</label>
									<select v-model="utilisateur">
										<option v-for="data in allUtilisateurs" v-bind:value="data.user.id"
										v-if="current_user_id == data.user.id || current_user_role == 'admin'">
											{{ data.user.name }}
										</option>
									</select>
								</div>
								<div class="form-group col-sm-4">
									<label for="client">Client</label>
									<select v-model="client" required @change="reporting">
										<option value="" selected disabled>Choisissez un client</option>
                    <template v-if="current_user_role == 'admin' || current_user_role == 'Consultant'">
                      <option class="row clients-assignes-content" :value="all_clients">
                        Tous les clients
                      </option>
                    </template>
										<template v-for="client in allClients">

											<template v-if="current_user_role == 'admin' || current_user_role == 'Consultant'">
												<option class="row clients-assignes-content" v-bind:value="client.id">
													{{ client.user.name }}
												</option>
											</template>
											<template v-else>
												<template v-for="utilisateur_assigne in client.utilisateur">
													<option class="row clients-assignes-content"  v-if="utilisateur == utilisateur_assigne.iduser" v-bind:value="client.id">
														{{ client.user.name }}
													</option>
												</template>
											</template>
										</template>
									</select>
								</div>
								<div class="form-group col-sm-4">
									<label for="entite">Entité</label>
									<select v-model="entite">
										<option value="" selected disabled>Choisissez une entité</option>
										<option v-for="data in allEntite" v-if="data && data.idclient == client" v-bind:value="data.id">
											{{ data.name }}
										</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="form-group col-sm-4">
									<label for="dateStart">Période</label>
									<datepicker v-model="date" min="2015-01-01" range></datepicker>
<!-- 									<input type="date" id="dateStart" v-model="dateStart" class="form-control">
									<label v-if="dateStart !== null" for="dateStart">Date de fin</label>
									<input type="date" id="dateEnd" v-if="dateStart !== null" v-model="dateEnd" class="form-control"> -->
								</div>
								<div class="form-group col-sm-4">
									<label for="temps">Temps</label>
									<div class="row">
										<div class="col-xs-6">
											<input type="number" v-model="heures" max="99" min="0" id="heure" class="form-control" placeholder="Heures">
										</div>
										<!--<input type="number" v-model="heures" max="99" min="0" id="heure" class="form-control" placeholder="Minutes" required>-->
										<div class="col-xs-6">
											<select v-model="min">
												<option v-for="minute in minutes">{{minute.text}}</option>
											</select>
										</div>
									</div>
								</div>
								<div class="checkbox col-sm-4">
									<div class="wrap">
										<div class="checkbox">
											<input v-model="hatvp" id="check" type="checkbox" name="check" value="check">
											<label for="check">Inclusion HATVP</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<hr class="hr-text" data-content="Action">
							<div class="row">
								<div class="form-group col-sm-4">
									<label for="catergorie">Catégorie</label>
									<select v-model="action_categorie" required>
										<option v-for="action_categorie in all_actions_categories"
												v-bind:value="action_categorie.id">
											{{ action_categorie.name }}
										</option>
									</select>
								</div>
								<div class="form-group col-sm-4">
									<!-- <label for="type">Type</label> -->
									<!-- <input type="text" id="type" v-model="action_type" class="form-control" required> -->
									<label for="type">Type</label>
									<select v-model="action_type" required>
										<option value="" selected disabled v-if="action_categorie === undefined">Choisissez une catégorie</option>
										<option v-for="action_type in all_actions_types" v-bind:value="action_type.id" v-if="action_type.idactioncategorie === action_categorie">
											{{ action_type.name }}
										</option>
									</select>
								</div>
								<div class="form-group col-sm-4">
									<label for="commentaire">Commentaire</label>
									<input type="text" id="comentaire" v-model="action_commentaire" class="form-control" required>
								</div>
							</div>
							<template v-if="updating != true || (recurring && updating == true)">
								<div class="row">
									<div class="checkbox col-sm-12">
										<div class="wrap">
											<div class="checkbox">
												<input v-model="recurring" id="recurring" type="checkbox" name="recurring" value="1">
												<label for="recurring" style="margin-top: 0;">Tâche récurrente</label>
											</div>
										</div>
									</div>
								</div>
								<div class="row" :style="recurring == 1 ? '' : 'opacity: 0.5;pointer-events:none'">
									<div class="form-group col-sm-4">
										<label for="starts_at">Date de début</label>
										<datepicker v-model="recurring_starts_at" min="2015-01-01" @selected="updateRecurringDetails()" :required="recurring == 1 ? true : false"></datepicker>
									</div>
									<div class="form-group col-sm-4">
										<label for="frequency">Répéter tous les</label>
										<div class="row">
											<div class="col-xs-6">
												<input type="number"  v-model="recurring_frequency" class="form-control" placeholder="10" v-on:change="updateRecurringDetails()" :required="recurring == 1 ? true : false">
											</div>
											<div class="col-xs-6">
												<select v-model="recurring_unit" :required="recurring == 1 ? true : false" v-on:change="updateRecurringDetails()">
													<option value="" selected disabled>jours</option>
													<option v-for="recurring_unit in recurring_units"
															v-bind:value="recurring_unit.value">
														{{ recurring_unit.name }}
													</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<label for="frequency">Se produira tous les</label>
										<select v-model="recurring_detail" :required="recurring == 1 ? true : false">
											<option v-for="recurring_detail in recurring_details"
													v-bind:value="recurring_detail.value">
												{{ recurring_detail.name }}
											</option>
										</select>
									</div>
								</div>
							</template>
						</div>
						<div class="col-md-12" :style="hatvp == 1 ? '' : 'opacity: 0.5;pointer-events:none'">
							<hr class="hr-text" data-content="HATVP">
							<div class="row">
								<div class="form-group col-sm-6">
									<label for="theme">Domaine(s) d'intervention *</label>
									<multiselect
										v-model="domaine_interventions"
										:options="all_domaines_interventions"
										:multiple="true"
										label="name"
										:required="hatvp == 1 ? true : false"
										track-by="id">
									</multiselect>
								</div>
								<div class="form-group col-sm-6">
									<label for="theme">Objet / Objectif poursuivi *</label>
									<input type="text" id="theme" v-model="action_theme" class="form-control" :required="hatvp == 1 ? true : false">
								</div>
							</div>
							<!-- <div class="row">
								<div class="form-group col-sm-8">
									<label for="position">Position défendue</label>
									<input type="text" id="position" v-model="action_position_defendue" class="form-control" :required="hatvp == 1 ? true : false">
								</div>
							</div> -->
							<div class="row">
								<div class="form-group col-sm-6">
									<label for="catergorie">Catégorie de responsable(s) public(s) sollicité(s) *</label>
									<multiselect
										v-model="decideur_publique_categorie"
										:options="all_decideurs_categories"
										:multiple="true"
										:required="hatvp == 1 ? true : false"
										label="name"
										track-by="id"></multiselect>
									<!-- <select v-model="decideur_publique_categorie" :required="hatvp == 1 ? true : false" multiple class="selectpicker">
										<option v-for="decideur_categorie in all_decideurs_categories"
												v-bind:value="decideur_categorie.id">
											{{ decideur_categorie.name }}
										</option>
									</select> -->
								</div>
								<div class="form-group col-sm-6">
									<label>Fonction du ou des responsable(s) public(s) sollicité(s)</label>
									<input type="text" v-model="decideur_publique_fonction" class="form-control">
								</div>
								<!-- <div class="form-group col-sm-4">
									<label for="nom_categorie">Nom</label>
									<input type="text" id="nom_catergorie" v-model="decideur_publique_nom" class="form-control">
								</div> -->
							</div>
							<div class="row">
								<div class="form-group col-sm-6">
									<label for="decision">Type(s) d’actions conduites *</label>
									<multiselect
										v-model="action_type_hatvp"
										:options="all_action_type_hatvp"
										:multiple="true"
										:required="hatvp == 1 ? true : false"
										label="name"
										track-by="id"></multiselect>
								</div>
								<div class="form-group col-sm-6">
									<label for="decision">Décision(s) publique(s) concernée(s) *</label>
									<multiselect
										v-model="decision_publique"
										:options="all_decision_publique"
										:multiple="true"
										label="name"
										track-by="id"
										:required="hatvp == 1 ? true : false"></multiselect>
								</div>
							</div>

						</div>
					</div>
					<div class="submit-btn">
						<button v-if="updating == false"  class="btn btn-default green-btn">Créer une entrée</button>
						<!-- <button v-if="updating == true" @click="cancelUpdate" class="btn btn-default green-btn">Annuler</button> -->
						<button v-if="updating == true" type="submit" class="btn btn-default green-btn">Modifier l'entrée</button>
					</div>
				</form>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="filters">
						<p class="clear" @click="clearFilter">
							<i class="fa fa-refresh" aria-hidden="true"></i> Réinitialiser tous les champs
						</p>
						<select v-model="filters.user" v-bind:class="{ active: filters.user }" @change="reporting">
							<option value="" selected disabled>Nom</option>
							<option v-for="user in allUtilisateurs" v-bind:value="user.id">{{ user.user.name }}</option>
						</select>
						<select v-model="filters.entite" v-bind:class="{ active: filters.entite }" @change="reporting">
							<option value="" selected disabled>Entité</option>
							<option v-for="data in allEntite" v-if="data.idclient == client" v-bind:value="data.id">{{ data.name }}</option>
						</select>
						<select v-model="filters.month" v-bind:class="{ active: filters.month }" @change="reporting">
							<option value="" selected disabled>Mois</option>
							<option value="00">Janvier</option>
							<option value="01">Février</option>
							<option value="02">Mars</option>
							<option value="03">Avril</option>
							<option value="04">Mai</option>
							<option value="05">Juin</option>
							<option value="06">Juillet</option>
							<option value="07">Août</option>
							<option value="08">Septembre</option>
							<option value="09">Octobre</option>
							<option value="10">Novembre</option>
							<option value="11">Décembre</option>
						</select>
						<select v-model="filters.year" v-bind:class="{ active: filters.year}" @change="reporting">
							<option value="" selected disabled>Année</option>
							<option v-for="(value, index) in filters.years" v-bind:value="value">{{ value }}</option>
						</select>
						<select v-model="filters.temps" v-bind:class="{ active: filters.temps }" @change="reporting">
							<option value="" selected disabled>Temps</option>
							<option value="2">Moins de 2h</option>
							<option value="4">Moins de 4h</option>
							<option value="6">Moins de 6h</option>
							<option value="8">Moins de 8h</option>
							<option value="10">Plus de 8h</option>
						</select>
						<select v-model="filters.action_categorie" v-bind:class="{ active: filters.action_categorie}" @change="reporting">
							<option value="" selected disabled>Catégorie</option>
							<option v-for="data in all_actions_categories" v-bind:value="data.id">{{ data.name }}</option>
						</select>
						<select v-model="filters.action_type" v-bind:class="{ active: filters.action_type }" @change="reporting">
							<option value="" selected disabled>Type</option>
							<option v-for="data in all_actions_types"
									v-if="data.idactioncategorie === filters.action_categorie || filters.action_categorie === ''"
									v-bind:value="data.id">{{ data.name }}</option>
						</select>
						<select v-model="filters.decideur_categorie" v-bind:class="{ active: filters.decideur_categorie }" @change="reporting">
							<option value="" selected disabled>Catégorie du décideur</option>
							<option v-for="data in all_decideurs_categories" v-bind:value="data.id">{{ data.name }}</option>
						</select>
					</div>
				</div>
			</div>
			<table class="table table-striped table-bordered desktop">
				<thead>
					<tr>
						<th>&nbsp;</th>
						<th>Client</th>
						<th>Nom</th>
						<th>Entité</th>
						<th>Date</th>
						<th>Temps</th>
						<th>Catégorie</th>
						<th>Type</th>
						<th>Commentaire Time-sheet</th>
						<th>Objet/Objectif poursuivi</th>
						<!-- <th>Position défendue</th> -->
						 <th>Domaine d'intervention</th> <!--Décision publique -->
						<th>Catégorie de responsable(s) public(s) sollicité(s)</th> <!-- Décideur catégorie -->
						<th>Type(s) d'actions conduites</th><!-- Décideur fonction -->
						<!-- <th>Décideur nom</th> -->
					</tr>
				</thead>
				<tbody>
					<tr v-for="reporting in allReporting" :class="id == reporting.id ? 'warning' : ''">
						<td @click="showShareMenu($event, reporting)" class="share-reporting">&#8942;</td>
						<td>{{ reporting.client.user.name }}</td>
						<td>{{ reporting.utilisateur.user.name }}</td>
						<td>
							<template v-if="reporting.entite">
								{{ reporting.entite.name }}
							</template>
						</td>
						<td>{{ reporting.dateclean }}</td>
						<td>{{ reporting.temps }}</td>
						<td>
							<template v-if="reporting.action_categorie">
								{{ reporting.action_categorie.name }}
							</template>
						</td>
            <td>
              {{ reporting.action_type.name }}
            </td>
            <td>{{ reporting.action_commentaire }}</td>
						<td>{{ reporting.action_theme }}</td>
						<!-- <td>{{ reporting.action_position_defendue }}</td> -->
						<!-- <th>Position défendue</th> -->
						<td>
							<template v-for="domaine_intervention in reporting.domaine_interventions">
								{{ domaine_intervention.name }}<br><br>
							</template>
						</td>
						<td>
							<template v-for="decideur_publique_categorie in reporting.decideur_publique_categorie">
								{{ decideur_publique_categorie.name }}<br><br>
							</template>
						</td>
						<td>
							<template v-for="action_h_a_t_v_p_type in reporting.action_h_a_t_v_p_type">
								{{ action_h_a_t_v_p_type.name }}<br><br>
							</template>
						</td>
						<!-- <td>{{ reporting.decideur_publique_nom }}</td> -->
					</tr>
				</tbody>
			</table>
			<div class="share-wrap" v-show="shareMenuVisible == 1">
				<div class="overlay_shareMenu" @click="hideShareMenu"></div>
				<div class="shareMenu">
					<i class="fa fa-times-circle fa-2x" aria-hidden="true" @click="hideShareMenu"></i>
					<ul>
						<li @click="shareNotification">Partager la ligne</li>
						<li @click="fillForUpdate">Modifier la ligne</li>
						<li @click="deleteReporting">Supprimer la ligne</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
</template>


<script>
import Vue from '../js/app.js'
import '../js/users.js'
import reportings from '../js/reporting.js'
import '../js/footable.js'
import datepicker from 'vue-date'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
	data() {
		return {
			id: this.$route.params.info,
			current_user_id: localStorage.id_user,
			current_user_role: localStorage.type_user,
			user_id_notification: null,
			infoEntree:{},
			shareId: null,
			allClients: null,
			client: '',
			allUtilisateurs: null,
			allEntite: null,
			allReporting: null,
			users_client: null,
			all_actions_categories: [],
			all_actions_types: [],
			all_decideurs_categories: [],
			all_decideurs_fonctions: [],
			all_decision_publique: [],
			utilisateur: localStorage.id_user,
			entite: '',
			date: [],
			dateStart: null,
			dateEnd: null,
			heures: null,
			min:'0',
			hatvp: null,
			action_categorie: undefined,
			action_type: null,
			action_commentaire: null,
			action_theme: null,
			action_type_hatvp: [],
			all_action_type_hatvp: [],
			action_position_defendue: null,
			decision_publique: [],
			decideur_publique_categorie: [],
			decideur_publique_fonction: null,
			decideur_publique_nom: null,
			success: false,
			updating: false,
			error: false,
			response: null,
			hatvp:false,
			showModal: false,
			oldest:null,
			domaine_interventions: [],
			all_domaines_interventions: [],
			recurring: null,
			recurring_units: [
				{'value':'day',
					'name':'Jour(s)'},
				{'value':'week',
					'name': 'Semaine(s)'},
				{'value':'month',
					'name': 'Mois'},
				{'value':'year',
					'name': 'Année(s)'},
			],
			recurring_details: [],
			recurring_starts_at: null,
			recurring_frequency: null,
			recurring_unit: null,
			recurring_detail: null,
			filters: {
				user:'',
				entite:'',
				month: ("0" + (new Date().getMonth())).slice(-2),
				year: new Date().getFullYear(),
				years:[new Date().getFullYear()],
				temps: '',
				action_categorie:'',
				action_type:'',
				decideur_categorie:'',
			},
			minutes: [
				{ text: '0', value: '0'},
				{ text: '0.25', value: '0.25'},
				{ text: '0.50', value: '0.50'},
				{ text: '0.75', value: '0.75'}
			],
			shareMenuVisible: false,
			all_clients : [],

		}
	},
	components: { datepicker, Multiselect },
	beforeCreate: function() {
		this.$nextTick(function() {
			this.clients();
			this.utilisateurs();
			this.entites();
			this.reporting();
			this.actioncategorie();
			this.actiontype();
			this.decideurcategorie();
			// this.decideurfonction();

			this.domaine();
			this.type_action_hatvp();
			this.decision();
		})
	},
	mounted() {
		if (this.$route.params.info) {
			if(this.$route.query.shared) {
				reportings.show(this, this.$route.params.info, 'sharedReporting',this.current_user_id);
			} else {
				this.fillForUpdate();
			}
		}
		Vue.http.get(
			'/api/reporting/autocomplete',
		).then(response => {
			this.ac_decisionpublique = response.data.data;
			$( "#decision_publique" ).autocomplete({
				source: this.ac_decisionpublique
			});
		});
	},
  watch: {
    recurring_starts_at: function () {
      this.updateRecurringDetails();
    },
	},
	methods: {
		resetForm() {
			// utilisateur
			// client
			this.entite = '';
			this.date = ["",""];
			this.heures = null;
			this.min = '0';
			this.hatvp = null;
			this.action_categorie = undefined;
			this.action_type = null;
			this.action_commentaire = null;
			this.recurring = null;
			this.recurring_starts_at = null;
			this.recurring_frequency = null;
			this.recurring_unit = null;
			this.recurring_detail = [];
			this.domaine_interventions = [];
			this.action_theme = null;
			this.decideur_publique_categorie = [];
			this.decideur_publique_fonction = null;
			this.action_type_hatvp = [];
			this.decision_publique = [];
		},
		updateRecurringDetails() {

			if(this.recurring_unit && this.recurring_frequency && this.recurring_starts_at) {
				this.recurring_details = [];

				if(this.recurring_unit == "month" || this.recurring_unit == "year") {
					let month = " du mois";
					let month_value = " of the month";
					let cur_moment = moment(this.recurring_starts_at);
					if( this.recurring_unit == "year" ) {
						month = " du mois de "+cur_moment.locale("fr").format('MMMM')
						month_value = " of "+cur_moment.format('MMMM')
					}
					this.recurring_details.push({
						"name":"Les "+cur_moment.locale("fr").format('D') + month,
						"value":"Every "+ cur_moment.format('D') + month_value})
					this.recurring_details.push({
						"name":"Les "+Math.ceil(cur_moment.format('D') / 7)+"e "+cur_moment.locale("fr").format('dddd')+month,
						"value":"Every "+ Math.ceil(cur_moment.format('D') / 7)+"th "+ cur_moment.locale('en').format('dddd') + month_value})

					if( Number(cur_moment.format('D')) + 7 > cur_moment.daysInMonth() ) {
						this.recurring_details.push({
							"name": "Les derniers "+cur_moment.locale("fr").format('dddd')+month,
							"value": "Last "+cur_moment.locale('en').format('dddd')+month_value})
					}
				} else {
					this.recurring_details.push({
						"name": "Les "+this.recurring_frequency+" "+this.recurring_unit,
						"value": "Every " + this.recurring_frequency+" "+this.recurring_unit})
				}
			}

		},
		clients() {
			let extraString = "";
			if (localStorage.type_user.toLowerCase() === 'consultant') {
				extraString = "&role=consultant";
			}
			let utilisateur = this.utilisateur;
			let all_clients = [];
			let current_user_role = this.current_user_role;
			Vue.http.get(
				'api/client/?section=list'+extraString,
			).then(response => {
				this.allClients = _.orderBy(response.data.data, 'name')

				if( current_user_role != 'admin' ) {
					for(let client of this.allClients) {
						for(let key in client.utilisateur) {
							if(utilisateur == client.utilisateur[key].iduser) {
								all_clients.push(client.id);
							}
						}
					}
				} else {
					all_clients = -1;
				}
				this.all_clients = all_clients;
				return this.allClients
			})
		},
		utilisateurs(){
			Vue.http.get(
				'api/utilisateurs',
			).then(response => {
				this.allUtilisateurs = _.orderBy(response.data.data, 'name')
			})
		},
		actioncategorie(){
			Vue.http.get(
				'api/actioncategorie'
			).then(response => {
				this.all_actions_categories = _.orderBy(response.data.data, 'name')
			})
		},
		actiontype() {
			Vue.http.get(
				'api/actiontype'
			).then(response => {
				this.all_actions_types =_.orderBy(response.data.data, 'name')
			})
		},
		decideurcategorie(){
			Vue.http.get(
				'api/decideurcategorie'
			).then(response => {
				this.all_decideurs_categories = _.orderBy(response.data.data, 'name')
			})
		},
		// decideurfonction() {
		// 	Vue.http.get(
		// 		'api/decideurfonction'
		// 	).then(response => {
		// 		this.all_decideurs_fonctions = _.orderBy(response.data.data, 'name')
		// 	})
		// },
		domaine() {
			Vue.http.get(
				'api/domaine'
			).then(response => {
				this.all_domaines_interventions = response.body
			})
		},
		type_action_hatvp() {
			Vue.http.get(
				'api/typeActionHatvp'
			).then(response => {
				this.all_action_type_hatvp = response.body
			})
		},
		decision() {
			Vue.http.get(
				'api/decision'
			).then(response => {
				this.all_decision_publique = response.body
			})
		},

		entites(){
			Vue.http.get(
				'api/entite'
			).then(response => {
				this.allEntite = _.orderBy(response.data.data, 'name')
			})
		},
		reporting(){
			if( this.client ) {
				console.log(this.client)
				Vue.http.post(
					'api/reporting',
					{
						idclient: this.client,
						filters: this.filters
					}
				).then(response => {
					this.allReporting = response.data.data;
					console.log(response.data.data[0])
					this.users_client = response.data.users_client;
					this.oldest = response.data.oldest;
					this.entite = null;
					if( this.filters.years.length <= 1 && this.filters.years[0] == new Date().getFullYear() ) {
						this.filters.year = new Date().getFullYear();
						this.filters.years = [];
						for( var i = this.oldest; i <= this.filters.year; i++) {
							this.filters.years.push(i)
						}
					}
					return this.allReporting;
				})
			}
		},
		excel() {
			if( this.client ) {
				Vue.http.post(
					'api/reporting/excel',
					{
						idclient: this.client,
						filters: this.filters
					}
				).then(response => {
					// footable.fooTable();
					window.open(response.body.file)
				})
			}
		},
		create(event) {
		  console.log(this);
			this.dateStart = this.date[0];
			this.dateEnd = this.date[1];
			reportings.create(this, this.$route.query.shared, this.$route.query.sharedBy)
			this.reporting();
			this.resetForm();
		},
		share(){
			reportings.share(this, this.current_user_id, this.client)
			this.$modal.hide('modal-share');
			this.showSuccessShare();
			this.shareMenuVisible = 0;
		},
		destroy(){
			reportings.destroy(this, this.id, this.current_user_id, this.client);
			this.$modal.hide('modal-confirm');
			this.shareMenuVisible = 0;
		},
		fillForUpdate() {
			reportings.show(this, this.id);
			this.updating = true;
			this.shareMenuVisible = false;
		},
		updateEntry() {
			this.dateStart = this.date[0];
			this.dateEnd = this.date[1];
			reportings.update(this);
			this.updating = false;
			this.shareMenuVisible = false;
		},
		cancelUpdate() {
			this.updating = false;
			this.shareMenuVisible = false;
		},
		submitForm(event) {
			event.preventDefault();
			if (this.updating === true) {
				this.updateEntry();
			} else {
				this.create();
			}
		},
		clearFilter() {
			this.filters.user='';
			this.filters.entite='';
			this.filters.month= ("0" + (new Date().getMonth())).slice(-2),
			this.filters.year= new Date().getFullYear();
			this.filters.temps= '';
			this.filters.action_categorie='';
			this.filters.action_type='';
			this.filters.decideur_categorie='';
			this.reporting();
		},
		showShareMenu($event,reporting) {
			this.shareMenuVisible = 1;
			this.id = reporting.id
			$('.shareMenu').css('left',event.layerX).css('top',event.layerY)
		},
		hideShareMenu() {
			this.shareMenuVisible = 0;
		},
		shareNotification() {
			this.$modal.show('modal-share');
		},
		deleteReporting() {
			this.$modal.show('modal-confirm')
		},
		showSuccessCreate() {
			this.$route.query.shared = '';
        	this.$route.query.sharedBy = '';
			this.$modal.show('dialog', {
				text: "L'entrée a bien été créée",
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessUpdate() {
			this.$modal.show('dialog', {
				text: "L'entrée a bien été modifiée",
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showError() {
			this.$modal.show('dialog', {
				text: 'Il y a eu une erreur imposible de compléter votre action',
				class: 'modal-error',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		showSuccessShare() {
			this.$modal.show('dialog', {
				text: "L'entrée a bien été partagée",
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
	}
}
</script>

<style src="../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// Reporting.vue?68b051c5